module.exports = __webpack_public_path__ + "static/p11_galloCola-10406231999b5446556d999cb4cbef43.png";